import { createFileRoute, Link } from '@tanstack/react-router';
import { type ReactNode } from 'react';
import { useIntlayer } from 'react-intlayer';

import { Button } from '~/components/ui/button';
import { HlsVideo } from '~/components/ui/hls-video';
import { ArrowUpRight } from '~/components/ui/icons';

export const NotFoundContent = ({ children }: { children?: ReactNode }) => {
  const common = useIntlayer('common');
  const errors = useIntlayer('errors');

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-black overflow-hidden">
      {/* Background video */}
      <div className="absolute inset-0">
        <HlsVideo
          src="/assets/video/hls/404page/master.m3u8"
          fallbackSrc="/assets/video/404page.mov"
          className="absolute inset-0 size-full bg-black object-cover object-center w-full h-full"
          playsInline
          loop
          muted
          autoPlay
          aria-label="Background video"
          poster="/assets/images/404firstframe.jpg"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center gap-[28px] text-center text-white px-[16px]">
        <div className="flex flex-col gap-[12px] items-center">
          <p className="font-['Fragment_Mono','Fragment_Mono_Fallback',monospace] text-xs tracking-[0.12px] uppercase text-[var(--color-graphite-700)]">{errors.subtitle}</p>
          <h1 className="font-['Fragment_Mono','Fragment_Mono_Fallback',monospace] font-normal text-[76px] leading-[1.2] tracking-[0.76px]">
            {errors.notFoundTitle}
          </h1>
          <p className="font-['Manrope','Manrope_Fallback',sans-serif] font-normal text-base lg:text-base max-w-[343px] lg:max-w-[606px]">
            {children || errors.notFoundDescription}
          </p>
        </div>
        <Button variant="glass" className="px-[24px] py-[10px] text-base" asChild>
          <Link to="/$locale" params={{ locale: 'en' }}>
            {common.home}
            <ArrowUpRight className="size-[14px]" />
          </Link>
        </Button>
      </div>
    </div>
  );
};

export const Route = createFileRoute('/404')({
  component: NotFoundContent,
});
